import React, { useEffect } from 'react';
import SubscribeSection from '../components/SubscribeSection';
import '../styles/episodes.css';

const Episodes = () => {
  useEffect(() => {
    // Create script element for Buzzsprout player
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.src = 'https://www.buzzsprout.com/2501774.js?container_id=buzzsprout-large-player&player=large';
    script.async = true;
    
    // Append script to the container after it exists in the DOM
    const container = document.getElementById('buzzsprout-large-player');
    if (container) {
      document.body.appendChild(script);
    }
    
    // Clean up function to remove script when component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h2>Episodes</h2>
        </div>
      </section>

      <section className="episodes-list">
        <div className="container">
          <div className="buzzsprout-container">
            <div id='buzzsprout-large-player'></div>
          </div>
        </div>
      </section>

      <div id="subscribe">
        <SubscribeSection />
      </div>
    </>
  );
};

export default Episodes;